/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ng-invalid[_ngcontent-%COMP%]:focus{border-left-color:#80bdff!important}#passwordReset[_ngcontent-%COMP%]{top:0;left:0}#incompatibleBrowserModal[_ngcontent-%COMP%]{z-index:3000!important}"];
export { styles as styles };
